import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { EDSApplication } from '@ellucian/react-design-system/core';

const EDSContent = (props) => {
    const { theme, globalLocale, localeDirection, children } = props;
    const intl = useIntl();

    return (
        <EDSApplication
            theme={theme}
            locale={globalLocale}
            dir={localeDirection}
            labelOverrides={{
                'component.DateRangePicker.error.overlappingDates': intl.formatMessage({ id: 'overlappingDateRangeError' }),
            }}
        >
            {children}
        </EDSApplication>
    );
};


EDSContent.propTypes = {
    theme: PropTypes.object,
    children: PropTypes.object,
    globalLocale: PropTypes.string,
    localeDirection: PropTypes.string
};

export default EDSContent;